<template>
  <!-- contractManagement add -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      width='700px'
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        :initReqHandle = 'initReqHandle'
        :isSubmitBtn="false"
      >
      <template slot="tip">
          <div class="tip_box">
            <i>支持扩展名：.pdf </i>
          </div>
        </template>
      <template slot="1" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-checkbox v-decorator="formItem.props" @change="onChange"></a-checkbox>
            <!-- <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/> -->
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      initReqHandle: false,
      modalTitle: '新增',
      visible: false,
      formList: [
        {
          label: '合同年度',
          inputType: 'select',
          options: [
          ],
          handle: '',
          placeholder: '请选择',
          props: ['contractYear', {
            rules: [{ required: true, message: '请选择合同年度' }]
          }]
        },
        {
          label: '合同母板',
          inputType: 'upload',
          options: [],
          handle: '',
          fileList: [],
          placeholder: '',
          tip: 'tip',
          beforeHandle: this.beforeUpload,
          limit: 1,
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'iconUrl',
            iconName: 'fileName',
            action: this.$store.state.uploadUrlJava,
            accept: '.pdf',
            limit: 1,
            uploadType: 6 // 上传的文件类型
          },
          props: ['icon', {
            rules: [{ required: true, message: '请上传合同PDF' }]
          }]
        }

      ],
      formKey: {
      },
      addParam: {
        url: ''
      },
      editParam: {
        url: ''
      },
      detailParam: {
        url: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 0, scope: 'formList', query: 'comu_local_annual_years'}
      ];
      this.dictionarySelect(paramArr);
    },
    show () {
      this.formList[1].fileList = [];
      this.visible = true;
    },
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        let obj = {};
        obj.contractYear = values.contractYear;
        obj.fileId = this.formList[1].fileList[0].uid;

        this.$post({
          url: '/local/contract/add',
          params: {
            ...obj
          }
        }).then((res) => {
          this.$message.success('操作成功');
          this.visible = false;
          this.$parent.$refs.table.getTableList();
        });
      });
    },
    beforeUpload (file, fileList, item) {
      const ispdf = file.type === 'application/pdf';
      if (!ispdf) {
        this.$message.error('请选择PDF格式的文件!');
      }
      return ispdf;
    },

    closeFun () {
      this.visible = false;
      this.formList[0].fileList = [];
    },
    ResHandle (res) {
      this.closeFun();
      return res;
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      let choseList = req.categoryIds;
      let arr = this.findFatherNode(choseList);
      req.categoryIds = arr;
      if (this.$route.query.menuId) {
        req.parentId = this.$route.query.menuId;
      }
      return req;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
